import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import {
    FETCH_COLLECTION_MODAL_DATA_LIST,
    FETCH_PRODUCT_MODAL_DATA_LIST
} from "../../../redux/actions";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useLocation } from "react-router-dom";


const ArrowButton = ({ data, selectedIndex, setSelectedIndex, setSelectedProductId, open }) => {

    const currentPage = useLocation().pathname

    const isCollection = (data?.is_collection || data?.files) ?? false;

    const [nextDisable, setNextDisable] = useState(false)
    const [prevDisable, setPrevDisable] = useState(false)
    const dispatch = useDispatch();

    const goToPreviousProduct = () => {
        if (isCollection) {
            if (data?.is_collection) {
                if (selectedIndex > 0) {
                    const newIndex = selectedIndex - 1;
                    setSelectedIndex(newIndex);
                    dispatch(setSelectedProductId(data?.collections[newIndex]?.id));
                    dispatch({ type: FETCH_COLLECTION_MODAL_DATA_LIST });
                }
            } else {
                if (selectedIndex > 0) {
                    const newIndex = selectedIndex - 1;
                    setSelectedIndex(newIndex);
                    dispatch(setSelectedProductId(data?.files[newIndex]?.id));
                    dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });
                }
            }
        } else {
            if (selectedIndex > 0) {
                const newIndex = selectedIndex - 1;
                setSelectedIndex(newIndex);
                if (currentPage === '/download') {
                    dispatch(setSelectedProductId(data[newIndex]?.id));
                } else {
                    dispatch(setSelectedProductId(data?.data[newIndex]?.id));
                }
                dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });
            }
        }

    };

    const goToNextProduct = () => {


        if (isCollection) {
            if (data?.is_collection) {
                if (selectedIndex < data.collections?.length - 1) {
                    const newIndex = selectedIndex + 1;
                    setSelectedIndex(newIndex);
                    dispatch(setSelectedProductId(data?.collections[newIndex]?.id));
                    dispatch({ type: FETCH_COLLECTION_MODAL_DATA_LIST });
                }
            } else {
                if (selectedIndex < data.files?.length - 1) {
                    const newIndex = selectedIndex + 1;
                    setSelectedIndex(newIndex);
                    dispatch(setSelectedProductId(data?.files[newIndex]?.id));
                    dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });
                }
            }
        } else {
            if (currentPage === '/download') {
                if (selectedIndex < data?.length - 1) {
                    const newIndex = selectedIndex + 1;
                    setSelectedIndex(newIndex);
                    dispatch(setSelectedProductId(data[newIndex]?.id));
                    dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });
                }
            } else {
                if (selectedIndex < data?.data?.length - 1) {
                    const newIndex = selectedIndex + 1;
                    setSelectedIndex(newIndex);
                    dispatch(setSelectedProductId(data?.data[newIndex]?.id));
                    dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });
                }
            }

        }

    };

    useEffect(() => {
        if (isCollection) {
            if (data?.is_collection) {
                // For collections
                setPrevDisable(selectedIndex === 0);
                setNextDisable(selectedIndex === data.collections?.length - 1);
            } else {
                // For files
                setPrevDisable(selectedIndex === 0);
                setNextDisable(selectedIndex === data.files?.length - 1);
            }
        } else {

            if (currentPage === '/download') {
                setPrevDisable(selectedIndex === 0);
                setNextDisable(selectedIndex === data?.length - 1);
            } else {
                setPrevDisable(selectedIndex === 0);
                setNextDisable(selectedIndex === data?.data?.length - 1);
            }
        }
    }, [selectedIndex, open, data, isCollection]);


    return (<div className='next-prev-item'>
        <Button type="text" disabled={selectedIndex <= 0} onClick={goToPreviousProduct}>
            <LeftOutlined className='arrow-btn' /> Previous
        </Button>
        <Button type="text" disabled={nextDisable} onClick={goToNextProduct}>
            Next <RightOutlined className='arrow-btn' />
        </Button>
    </div>)
}

export default ArrowButton
